import linkRuleHover from '../../../common/algorithms/link-rule-hover';

const light = (params) => linkRuleHover(params);

export default light;
